<template>
  <div class="page" style="padding-top:0;">
    <div>
      <div class="fullpage">
        <iframe
          src="https://www.google.com/maps/d/embed?mid=1FjIcmr8wQCjWk1lKD5-aGIJS1sKdbNKt&hl=nl"
          width="100%"
          height="100%"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "kaart"
};
</script>

<style>
.fullpage {
  height: 100vh;
}
</style>